import React from 'react';

type FillColor = string;
type ClassName = string;

interface IProps {
  fillColor: FillColor;
  className: ClassName;
}

const HourglassIcon = ({
  fillColor = '#53585E',
  className = '',
}: IProps): React.ReactElement<React.ReactNode> => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 21 36"
    className={className}
  >
    <path
      fill={fillColor}
      d="M13.8445 19.5175L13.8205 19.504L13.7958 19.4918L13.6666 19.4282C13.0431 19.0545 12.7232 18.4829 12.7232 17.9398C12.7232 17.3619 13.0344 16.8145 13.6095 16.4996L13.755 16.4279L13.7797 16.4158L13.8037 16.4023C17.1968 14.493 19.3283 11.2997 19.3283 7.74156V3.73775C19.3283 2.74364 18.5224 1.93775 17.5283 1.93775H3.4309C2.43679 1.93775 1.6309 2.74363 1.6309 3.73775V7.74156C1.6309 11.2805 3.73949 14.4584 7.10061 16.3712L7.21492 16.4556L7.27263 16.4982L7.33582 16.5322C7.91982 16.8459 8.23605 17.3974 8.23605 17.98C8.23605 18.5579 7.92485 19.1052 7.34977 19.4202L7.20419 19.4918L7.1795 19.504L7.15552 19.5175C3.76247 21.4268 1.6309 24.6201 1.6309 28.1782V32.2623C1.6309 33.2564 2.43679 34.0623 3.4309 34.0623H17.5691C18.5632 34.0623 19.3691 33.2564 19.3691 32.2623V28.1782C19.3691 24.6201 17.2375 21.4268 13.8445 19.5175Z"
      stroke="#8940FA"
      strokeWidth="2"
    />
    <path
      d="M14.8156 12.3791C15.0446 12.1365 14.8636 11.7565 14.53 11.7565H6.44881C6.11912 11.7565 5.93671 12.129 6.15904 12.3724C6.78055 13.0529 7.54812 13.6692 8.46174 14.1656L8.62483 14.2459C9.19684 14.5677 9.67787 14.9971 10.0436 15.4981C10.2497 15.7804 10.7511 15.7804 10.9571 15.4981C11.3229 14.9971 11.8039 14.5677 12.3759 14.2459L12.539 14.1656C13.4399 13.6455 14.1987 13.0323 14.8156 12.3791Z"
      fill="#8940FA"
    />
    <path
      d="M10.8565 21.8283C10.6814 21.6007 10.3225 21.6031 10.1514 21.8337C9.77902 22.3354 9.16887 23.0796 8.62462 23.3859L8.46153 23.4662C5.85209 24.9517 4.30273 27.3206 4.30273 29.8501V30.6561C4.30273 31.098 4.66091 31.4561 5.10273 31.4561H15.9791C16.421 31.4561 16.7791 31.098 16.7791 30.6561V29.8501C16.7791 27.3206 15.2298 24.9116 12.6203 23.4662L12.4572 23.3859C11.8631 23.0552 11.2362 22.3215 10.8565 21.8283Z"
      fill="#8940FA"
    />
  </svg>
);

export { HourglassIcon };
